export const getClientConfig = () =>
  JSON.parse(localStorage.getItem("client_config"));
export const deleteClientConfig = () =>
  localStorage.removeItem("client_config");
export const setClientConfig = client_config => {
  localStorage.setItem("client_config", JSON.stringify(client_config));
};
